export const black = '#191308';

export const primaryColor = '#264BAB'; // primary50

export const primary100 = '#1A3C94';

export const primary10 = '#E9EFFF';

export const errorColor = '#DC3030'; // red100

export const red10 = '#FEEEEE';

export const red100 = '#DC3030';

export const gray10 = '#F6F7F9';

export const gray20 = '#EAECF1';

export const gray70 = '#D8D9DB';

export const gray80 = '#B6B8BD';

export const gray90 = '#808080';

export const gray100 = '#191308';

export const yellow = '#F6AE2D';

export const pink = '#EF6461';

export const white = '#FFF';

export const green100 = '#036039';

export const green50 = '#26AB73';

export const green10 = '#D6F1E6';

export const primaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: gray70,
    color: white
  },
  '&:hover': {
    backgroundColor: primaryColor,
    boxShadow: 'none',
    color: white,
    opacity: '80%'
  },
  backgroundColor: primaryColor,
  boxShadow: 'none',
  color: white
};

export const tertiaryButtonOutlinedColor = {
  '&:disabled': {
    color: gray70,
    opacity: '80%'
  },
  '&:hover': {
    border: `1px solid ${gray80}`,
    boxShadow: 'none',
    color: gray100,
    opacity: '80%'
  },
  border: `1px solid ${gray80}`,
  boxShadow: 'none',
  color: gray100,
  fontWeight: '500'
};

export const alertButtonOutlinedColor = {
  '&:disabled': {
    borderColor: gray70,
    color: gray70
  },
  '&:hover': {
    backgroundColor: 'inherit',
    borderColor: errorColor,
    boxShadow: 'none',
    color: errorColor,
    opacity: '80%'
  },
  backgroundColor: white,
  border: `1px solid ${gray80}`,
  boxShadow: 'none',
  color: errorColor,
  fontWeight: '500'
};

export const primaryButtonOutlinedColor = {
  '&:disabled': {
    borderColor: gray70,
    color: gray70
  },
  '&:hover': {
    backgroundColor: 'inherit',
    borderColor: primaryColor,
    boxShadow: 'none',
    color: primaryColor,
    opacity: '80%'
  },
  fontWeight: '500',
  borderColor: primaryColor,
  boxShadow: 'none',
  color: primaryColor
};

export const primary10ButtonOutlinedColor = {
  '&:disabled': {
    borderColor: gray70,
    color: gray70
  },
  '&:hover': {
    backgroundColor: primary10,
    borderColor: primaryColor,
    boxShadow: 'none',
    color: primaryColor,
    opacity: '80%'
  },
  backgroundColor: primary10,
  borderColor: primaryColor,
  boxShadow: 'none',
  color: primaryColor,
  fontWeight: '500'
};

export const linkColor = {
  '&:hover': {
    color: '#0A7EBF',
    textDecorationColor: '#0A7EBF'
  },
  color: gray100,
  fontSize: '12px',
  textDecorationColor: gray100
};

export const primaryLinkColor = {
  '&:hover': {
    opacity: '80%'
  },
  color: primaryColor,
  fontSize: '16px',
  fontWeight: '500',
  textDecorationColor: primaryColor,
  cursor: 'pointer'
};

export const changeHeaderColorByEnv = (): string => {
  const env = process.env.REACT_APP_ENV;
  if (env === 'dev') {
    return '#264BAB';
  } else if (env === 'stg') {
    return '#264BAB';
  }
  return '#264BAB';
};
